"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { Badge } from "@/components/ui/badge";
import { Twitter, Linkedin, Github, Dribbble, Instagram } from "lucide-react";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <ul className="flex flex-col gap-3">
        {[1, 2, 3, 4].map((_, i) => <li key={i} data-index={i}>
            <div className="h-4 w-24 bg-muted animate-pulse rounded-sm" />
          </li>)}
      </ul>;
  }
  return <ul className="flex flex-col gap-3">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-sm text-muted-foreground hover:text-primary transition-colors duration-200 font-default">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function Footer() {
  const services = ["Phone:+1 610-549-8900", "Email: jk.floorsremoval@gmail.com", "Sacramento, California", "Licensed & Insured Pro", "Serving All Nearby Areas", "Free Estimates & Quotes"];
  const currentYear = new Date().getFullYear();
  return <section data-section-id="204777" id="footer" className="dark bg-background text-foreground border-t border-border pt-16 pb-8">
      <div className="container mx-auto px-6 md:px-8 max-w-7xl">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8">
          {}
          <div className="flex flex-col gap-6 lg:pr-8">
            <Link to="#">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1623242/img/siterevive_logo.png" alt="Kim & Julio Home Renewals" className="h-7 w-auto object-contain" />
            </Link>
            <p className="text-sm text-muted-foreground leading-relaxed font-default">
              Kim & Julio Home Renewals provides outdoor assembly, furniture assembly, floor and carpet removal, deep carpet cleaning and wood floor treatment in Sacramento. We focus on quality work and reliable service for everyone.
          </p>
            </div>

          {}
          <div className="flex flex-col gap-6">
            <h4 className="font-default font-extrabold text-foreground tracking-tighter">
              Quick Links
            </h4>
            <MenuProvider menu_id="footer_menu">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <h4 className="font-default font-extrabold text-foreground tracking-tighter">
              Contact Details
            </h4>
            <ul className="flex flex-col gap-3">
              {services.map((service, i) => <li key={i} data-index={i}>
                  <Link to="#" className="text-sm text-muted-foreground hover:text-primary transition-colors duration-200 line-clamp-1 font-default">
                    {service}
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <h4 className="font-default font-extrabold text-foreground tracking-tighter">
              Social Media
            </h4>
            <div className="flex flex-wrap gap-3">
              <Link to="#" className="flex items-center justify-center size-10 rounded-md border border-border bg-card hover:border-primary hover:text-primary transition-all duration-300 text-muted-foreground shadow-sm hover:shadow-md group" aria-label="Twitter">
                <Twitter className="size-4 group-hover:scale-110 transition-transform" />
              </Link>
              <Link to="#" className="flex items-center justify-center size-10 rounded-md border border-border bg-card hover:border-primary hover:text-primary transition-all duration-300 text-muted-foreground shadow-sm hover:shadow-md group" aria-label="LinkedIn">
                <Linkedin className="size-4 group-hover:scale-110 transition-transform" />
              </Link>
              <Link to="#" className="flex items-center justify-center size-10 rounded-md border border-border bg-card hover:border-primary hover:text-primary transition-all duration-300 text-muted-foreground shadow-sm hover:shadow-md group" aria-label="GitHub">
                <Github className="size-4 group-hover:scale-110 transition-transform" />
              </Link>
              <Link to="#" className="flex items-center justify-center size-10 rounded-md border border-border bg-card hover:border-primary hover:text-primary transition-all duration-300 text-muted-foreground shadow-sm hover:shadow-md group" aria-label="Dribbble">
                <Dribbble className="size-4 group-hover:scale-110 transition-transform" />
              </Link>
              <Link to="https://www.instagram.com/floorsremovalsac/" target="_blank" rel="noopener noreferrer" className="flex items-center justify-center size-10 rounded-md border border-border bg-card hover:border-primary hover:text-primary transition-all duration-300 text-muted-foreground shadow-sm hover:shadow-md group" aria-label="Instagram">
                <Instagram className="size-4 group-hover:scale-110 transition-transform" />
              </Link>
            </div>
          </div>
        </div>

        {}
        <div className="mt-16 pt-8 border-t border-border flex flex-col md:flex-row justify-between items-center gap-6">
          <p className="text-sm text-muted-foreground font-default">
            © {currentYear} Kim & Julio Home Renewals. All rights reserved.
          </p>
          <Link to="https://api.whatsapp.com/send?phone=16105498900&text=Hi%20I%20need%20a%20quote" newTab>
            <Badge variant="outline" className="text-emerald-500 border-emerald-500/30 bg-emerald-500/10 font-mono uppercase tracking-wider text-[10px] py-1 px-3">
              <span className="relative flex size-2 mr-2">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-500 opacity-75"></span>
                <span className="relative inline-flex rounded-full size-2 bg-emerald-500"></span>
              </span>
              WhatsApp: Online
            </Badge>
          </Link>
        </div>
      </div>
    </section>;
}